/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-29 09:53:43
 * @LastEditors: limin
 * @LastEditTime: 2021-04-22 17:27:20
 */
import Vue from "vue";
import Router from "vue-router";
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject){
//     return originalPush.call(this, location, onResolve, onReject)
//   }
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router);
import routes from "./routes";
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果savedPosition存在，滚动条会自动跳到记录的值的地方
      return savedPosition;
    }
    return { x: 0, y: 0 }; // savedPosition也是一个记录x轴和y轴位置的对象
  },
  routes
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (window.vm) {
    window.vm.fromPath = from.path;
    window.vm.$store.dispatch("common/setIsShowTabBar", to.name);
  }
  next();
});
export default router;
